// baseApi.ts
import { baseUrl } from '@/helpers/config/baseUrl';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setCredentials } from '../features/authSlice';
import { RootState } from '../store';

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl(),
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithRefreshToken = async (
  args: any,
  api: any,
  extraOptions: any,
) => {
  const result = await baseQuery(
    {
      ...args,
      body: args.data,
    },
    api,
    extraOptions,
  );

  if (result.error?.status === 401) {
    // if the session is expired, logout the user
    // @ts-ignore
    if (result.error?.data?.message.startsWith('Your session has expired.')) {
      api.dispatch(setCredentials({ user: null, accessToken: null }));
      return result;
    }

    const res = await fetch(
      `${baseUrl()}/user-authentication/create-refresh-token/`,
      {
        method: 'POST',
        credentials: 'include',
      },
    );
    const refreshResult = await res.json();

    if (refreshResult) {
      const user = (api.getState() as RootState).auth.user;

      api.dispatch(
        setCredentials({
          user,
          accessToken: refreshResult?.body?.accessToken,
        }),
      );
    }
    if (res?.status === 401) {
      api.dispatch(
        setCredentials({
          user: refreshResult?.body?.user,
          accessToken: refreshResult?.body?.accessToken,
        }),
      );
    }

    return await baseQuery(args, api, extraOptions);
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithRefreshToken,
  endpoints: () => ({}),
  tagTypes: [
    'user',
    'appointment',
    'category',
    'blog',
    'auth',
    'product',
    'doctor',
    'accessories',
    'gallery',
    'courses',
  ],
});
